import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Dialog } from "antd-mobile";
import { useStores } from "../../models";
import useNavigation from "../../hooks/useNavigation";

const ExchangeAlert = () => {
  const { walletStore } = useStores();
  const { navigate } = useNavigation();

  useEffect(() => {
    if (!walletStore.isExchangeAlertShowing || !walletStore.exchangeOrderData) {
      return;
    }
    const data: any = walletStore.exchangeOrderData;
    Dialog.alert({
      title: "充值成功",
      content: `订单 ${data.ex_order_no || ""} 已到账 ${data.amount || ""}`,
      confirmText: "查看",
      onConfirm: () => {
        walletStore.clearExchangeAlert();
        navigate("Wallet");
      },
    });
  }, [
    walletStore.isExchangeAlertShowing,
    walletStore.exchangeOrderData,
    walletStore,
    navigate,
  ]);

  return null;
};

export default observer(ExchangeAlert);
